import { Injectable } from '@angular/core';
import { ILocation } from 'src/app/interfaces/location';
import { ApiService } from 'src/app/services/api.service';

import { endpoints } from 'src/app/constants/endpoints';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class LocationApiService {
  constructor(
    private Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public geocode(Location: ILocation) {
    // const address = {};
    // !!Location.housenumber && (address['housenumber'] = Location.housenumber);
    // !!Location.street && (address['street'] = Location.street);
    // !!Location.city && (address['city'] = Location.city);
    // !!Location.county && (address['county'] = Location.county);
    // !!Location.postalcode && (address['postalcode'] = Location.postalcode);
    // const endpoint = environment.endpoint.organisationAdmin.geocode();
    // const method = 'POST';
    // const body = {address};
    // const options = {body};
    // return this.Api.rawRequest(method, endpoint, options).then(
    //   result => result,
    //   error => this.Api.handleError(error)
    // );
  }

  public listWithPageEvent(
    role: string,
    endpointUrl: string,
    filter?: {},
    OrgId?: number,
    PageEvent?: PageEvent
  ) {
    const endpointConfig = endpoints.organisations[endpointUrl];
    let endpoint = `${role}/${endpointConfig}/product-id/${OrgId}/locations`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) =>
        this.Api.handleError(error).then(() => Promise.reject())
      );
  }

  public save(
    role: string,
    organisationId: number,
    locationId: number,
    Location: ILocation
  ) {
    return this.update(role, organisationId, locationId, Location);
  }

  private update(
    role: string,
    organisationId: number,
    locationId: number,
    Location: ILocation
  ) {
    const endpoint = this.endpoint(role, organisationId, locationId);

    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.put(endpoint, Location, url).then(
      (id) => {
        this.Api.handleSuccess(Location.title + ' saved.');
        return id;
      },
      (error) => this.Api.handleError(error)
    );
  }

  protected endpoint(
    role: string,
    organisationId: number,
    locationId?: number
  ) {
    let endpoint = `${role}/organisation-id/${organisationId}/location/${locationId}`;

    return endpoint;
  }
}
